module.exports = __webpack_public_path__ + "static/media/build-1.cbdc9158.jpg";